import React, { Fragment } from 'react';
import { WeaLocaleProvider } from 'ecCom';
import { ExcelTableCellProps } from '../TableCell';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import InputElement from './input-element';
import TextareaElement from './textarea-element';
import BrowserElement from './browser-element';
import CheckboxElement from './checkbox-element';
import SelectElement from './select-element';
import UploadElement from './upload-element';
import HrefElement from './href-element';
import SelLevelElement from './seclevel-element';
import { getDomIdByFieldKey } from '../../../util/typeUtil';
import PopoverTips from '../PopoverTips';
import { CellProps } from '../../../stores/card/ModeExcel';
import { modeForm } from '../../../util/excelUtil';
const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class ExcelTableCellField extends React.Component<ExcelTableCellProps, any> {
    renderContent = (bindObj, cell: CellProps) => {
        const {  form, card, index,excel } = this.props;
        const path = cell.getPath();
        const { fieldhtmltype = '0' } = card.getFieldProps(path)
        const { isHide, viewAttr, value } = bindObj.bind();
        const classNames = (bindObj.isValid||!!bindObj.value) ? 'cube-check-valid' : 'cube-check-error';
        if (fieldhtmltype == '0') {
            return <div />
        }
        if (typeof (card.getEcmeFieldData) == 'function') {
            try {
                let fieldData = card.getEcmeFieldData(path, bindObj.bind());
                let domid = getDomIdByFieldKey(bindObj.path);
                if (fieldData) {
                    return <div className={classnames('fieldValue', classNames)} data-fieldmark={domid} {...cell.cellProps}>{fieldData}</div>;
                }
            } catch (e) { }

        }
        if ((isHide || viewAttr == '4')) {
            let domid = getDomIdByFieldKey(bindObj.path);
            return <div className={classnames('fieldValue', classNames)} data-fieldmark={domid} {...cell.cellProps}>
                <input
                    type="hidden"
                    id={domid}
                    name={domid}
                    value={value} />
            </div>
        } else {
            if (path === 'field-9') {
                return (
                    <SelLevelElement ecId={`${this && this.props && this.props.ecId || ''}_SelLevelElement@5lai9y`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index}/>
                )
            }
            if (fieldhtmltype == '1') { //单行文本
                return (
                    <InputElement ecId={`${this && this.props && this.props.ecId || ''}_InputElement@5lai4y`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '2') { //多行文本
                return (
                    <TextareaElement ecId={`${this && this.props && this.props.ecId || ''}_TextareaElement@t2k0s0`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '3') { //浏览框、日期、时间
                return (
                    <BrowserElement ecId={`${this && this.props && this.props.ecId || ''}_BrowserElement@o9ozcv`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '4') { //check框
                return (
                    <CheckboxElement ecId={`${this && this.props && this.props.ecId || ''}_CheckboxElement@m959ut`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '5') {//选择框
                return (
                    <SelectElement ecId={`${this && this.props && this.props.ecId || ''}_SelectElement@wpmxr8`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index}/>
                )
            } else if (fieldhtmltype == '6') { //附件上传
                return (
                    <UploadElement ecId={`${this && this.props && this.props.ecId || ''}_UploadElement@zs496o`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '7') { //特殊字段
                return (
                    <HrefElement ecId={`${this && this.props && this.props.ecId || ''}_HrefElement@eg5b02`} cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            }

        }

        return (
            <div />
        )
    }

    proxyCompFn = (bindObj, cell: CellProps) => {
        // const forceRender = ;     //仅为强制render
        // const { card } = this.props;
        let fieldName = getDomIdByFieldKey(bindObj.path);

        const { _viewAttr, isEdit, isMandatory } = bindObj.bind();
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        // const { forceRender} = bindObj.bind();
        // console.log(forceRender)
        const result: any = [];
       const _fieldName = fieldName.indexOf('_') >0 ? fieldName.split('_')[0] :fieldName; //#813884加的，但是影响了明细表的渲染
        let proxyCompFn; // modeForm.getCustomProxyCompFn(`FieldContent_${fieldName}`);
        /***
         * 客户需要根据字段，不用加行号，所有行修改
         */
        if(`FieldContent_${fieldName}` in modeForm.proxyCompFn){ 
            proxyCompFn = modeForm.getCustomProxyCompFn(`FieldContent_${fieldName}`);
        }else{
            proxyCompFn = modeForm.getCustomProxyCompFn(`FieldContent_${_fieldName}`);
        }

        if (proxyCompFn === null) {
            const proxyComp = modeForm.renderCustomComp(fieldName, viewAttr, 1, this.props);
            const afterComp = modeForm.renderCustomComp(fieldName, viewAttr, 2);
            result.push(proxyComp == null ? this.renderContent(bindObj, cell) : proxyComp);
            if (afterComp !== null)
                result.push(afterComp);
        } else {
            const fieldinfo = modeForm.getFieldInfo(fieldName);
            const needFieldInfo = {
                fieldMark: fieldName,
                fieldValue: modeForm.getFieldValue(fieldName),
                fieldid: fieldinfo.fieldid,
                rowIndex: fieldinfo.isdetail ? fieldName.split('_')[1] : '-1',
                viewAttr: fieldinfo.viewattr,
            };
            result.push(proxyCompFn(needFieldInfo, this.renderContent.bind(this, bindObj, cell)));
        }
        return result;
    }

    render() {
        const { cell, form } = this.props;
        const path = cell.getPath()
        const bindObj = form.has(path) ? form.$(path) : {};
        if (path==='field-9') {
            const bindObj10 = form.has('field-10') ? form.$('field-10') : {};
            return (
                <Fragment ecId={`${this && this.props && this.props.ecId || ''}_Fragment@c3rbzc`}>
                    <PopoverTips ecId={`${this && this.props && this.props.ecId || ''}_PopoverTips@140uco`}
                        error={bindObj.tips ? bindObj.tips : { visible: false, msg: '' }}
                        type="error"
                        label={bindObj.label}>
                        {bindObj.bind ? <Fragment ecId={`${this && this.props && this.props.ecId || ''}_Fragment@uv7ps3`}  >{this.proxyCompFn(bindObj, cell)}</Fragment> : <div />}
                    </PopoverTips>
                    <PopoverTips ecId={`${this && this.props && this.props.ecId || ''}_PopoverTips@149uco`}
                        error={bindObj10.tips ? bindObj10.tips : { visible: false, msg: '' }}
                        type="error"
                        label={getLabel('131188','保密期限')}>
                        <div style={{height: 28}} />
                    </PopoverTips>
                </Fragment>
            )
        }
        return (
            <PopoverTips ecId={`${this && this.props && this.props.ecId || ''}_PopoverTips@148uco`}
                error={bindObj.tips ? bindObj.tips : { visible: false, msg: '' }}
                type="error"
                label={bindObj.label}>
                {bindObj.bind ? <Fragment ecId={`${this && this.props && this.props.ecId || ''}_Fragment@ybyw61`}  >{this.proxyCompFn(bindObj, cell)}</Fragment> : <div />}
            </PopoverTips>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/index.tsx